module.exports = __webpack_public_path__ + "static/media/logo_eng.cc787ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo_eng.png
// module id = 42
// module chunks = 0